var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelsIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27259_7329)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 12.5,
    fill: "#E6F6F6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "gear-main"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8274 17.5342C48.2985 15.2 51.7015 15.2 53.1726 17.5342L54.2894 19.3064C55.3915 21.0552 57.7011 21.5824 59.4528 20.4849L61.228 19.3728C63.5661 17.908 66.6322 19.3845 66.9448 22.1258L67.1821 24.2071C67.4163 26.261 69.2684 27.738 71.3228 27.5092L73.4048 27.2775C76.1469 26.9722 78.2686 29.6328 77.3609 32.2383L76.6716 34.2164C75.9915 36.1685 77.0193 38.3028 78.9696 38.9882L80.9459 39.6827C83.5489 40.5974 84.3062 43.9151 82.3578 45.8687L80.8786 47.3519C79.4188 48.8155 79.4188 51.1845 80.8786 52.6481L82.3578 54.1313C84.3062 56.0849 83.5489 59.4026 80.9459 60.3173L78.9696 61.0118C77.0193 61.6972 75.9915 63.8315 76.6716 65.7836L77.3609 67.7617C78.2686 70.3672 76.1469 73.0278 73.4048 72.7225L71.3228 72.4908C69.2684 72.262 67.4163 73.739 67.1821 75.7929L66.9448 77.8742C66.6322 80.6155 63.5661 82.092 61.228 80.6272L59.4528 79.5151C57.7011 78.4176 55.3915 78.9448 54.2894 80.6936L53.1726 82.4658C51.7015 84.8 48.2985 84.8 46.8274 82.4658L45.7106 80.6936C44.6085 78.9448 42.2989 78.4176 40.5472 79.5151L38.772 80.6272C36.4339 82.092 33.3678 80.6155 33.0552 77.8742L32.8179 75.7929C32.5837 73.739 30.7316 72.262 28.6772 72.4908L26.5952 72.7225C23.8531 73.0278 21.7314 70.3671 22.6391 67.7617L23.3284 65.7836C24.0085 63.8315 22.9807 61.6972 21.0304 61.0118L19.0541 60.3173C16.4511 59.4026 15.6939 56.0849 17.6422 54.1313L19.1214 52.6481C20.5812 51.1845 20.5812 48.8155 19.1214 47.3519L17.6422 45.8687C15.6939 43.9151 16.4511 40.5974 19.0541 39.6827L21.0304 38.9882C22.9807 38.3028 24.0085 36.1685 23.3284 34.2164L22.6391 32.2383C21.7314 29.6328 23.8531 26.9722 26.5952 27.2775L28.6772 27.5092C30.7316 27.738 32.5837 26.261 32.8179 24.2071L33.0552 22.1258C33.3678 19.3845 36.4339 17.908 38.772 19.3728L40.5472 20.4849C42.2989 21.5824 44.6085 21.0552 45.7106 19.3064L46.8274 17.5342Z",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 23.125,
    stroke: "white",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 17.5,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 8.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 6.25,
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 36.875,
    r: 1.875,
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 63.125,
    r: 1.875,
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7193,
    cy: 40.7192,
    r: 1.875,
    transform: "rotate(-45 40.7193 40.7192)",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.2808,
    cy: 59.2808,
    r: 1.875,
    transform: "rotate(-45 59.2808 59.2808)",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.875,
    cy: 50,
    r: 1.875,
    transform: "rotate(-90 36.875 50)",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.125,
    cy: 50,
    r: 1.875,
    transform: "rotate(-90 63.125 50)",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7192,
    cy: 59.2808,
    r: 1.875,
    transform: "rotate(-135 40.7192 59.2808)",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.2808,
    cy: 40.7192,
    r: 1.875,
    transform: "rotate(-135 59.2808 40.7192)",
    fill: "#00A3A4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "gear-sub",
    opacity: 0.3,
    d: "M63.3343 -23.0332C62.724 -25.7239 65.1303 -28.1302 67.821 -27.5199L69.8639 -27.0564C71.8798 -26.5991 73.8856 -27.8595 74.3483 -29.8742L74.8172 -31.9158C75.4347 -34.6049 78.6468 -35.7289 80.8062 -34.0115L82.4457 -32.7076C84.0636 -31.4209 86.4176 -31.6861 87.7086 -33.3006L89.0169 -34.9366C90.74 -37.0914 94.1217 -36.7104 95.3221 -34.2262L96.2335 -32.3401C97.1329 -30.4788 99.3689 -29.6964 101.233 -30.5908L103.121 -31.4972C105.608 -32.691 108.49 -30.8805 108.494 -28.1214L108.496 -26.0266C108.499 -23.9595 110.174 -22.2844 112.241 -22.2816L114.336 -22.2788C117.095 -22.2752 118.906 -19.3937 117.712 -16.9063L116.806 -15.0177C115.911 -13.1541 116.694 -10.9181 118.555 -10.0187L120.441 -9.10732C122.925 -7.9069 123.306 -4.52524 121.151 -2.80212L119.515 -1.49386C117.901 -0.202849 117.636 2.15117 118.922 3.76906L120.226 5.40857C121.944 7.56798 120.82 10.7801 118.131 11.3976L116.089 11.8665C114.074 12.3291 112.814 14.335 113.271 16.3509L113.735 18.3938C114.345 21.0845 111.939 23.4908 109.248 22.8804L107.205 22.417C105.189 21.9597 103.183 23.2201 102.721 25.2348L102.252 27.2764C101.634 29.9655 98.4221 31.0894 96.2627 29.3721L94.6232 28.0682C93.0053 26.7815 90.6513 27.0467 89.3603 28.6612L88.0521 30.2972C86.3289 32.452 82.9473 32.071 81.7469 29.5868L80.8354 27.7007C79.9361 25.8394 77.7001 25.057 75.8364 25.9514L73.9479 26.8578C71.4605 28.0516 68.579 26.2411 68.5753 23.482L68.5725 21.3872C68.5698 19.3201 66.8947 17.645 64.8275 17.6422L62.7328 17.6394C59.9737 17.6358 58.1632 14.7543 59.357 12.2669L60.2633 10.3783C61.1578 8.5147 60.3754 6.27872 58.5141 5.37933L56.628 4.46792C54.1438 3.2675 53.7627 -0.114168 55.9176 -1.83728L57.5536 -3.14555C59.168 -4.43655 59.4333 -6.79057 58.1466 -8.40846L56.8427 -10.048C55.1253 -12.2074 56.2493 -15.4195 58.9383 -16.037L60.98 -16.5059C62.9947 -16.9685 64.255 -18.9744 63.7977 -20.9903L63.3343 -23.0332Z",
    fill: "#00A3A4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gear-sub",
    opacity: 0.3,
    d: "M27.8329 94.3945C27.2225 91.7038 29.6288 89.2975 32.3195 89.9078L34.3624 90.3712C36.3784 90.8285 38.3842 89.5682 38.8469 87.5535L39.3157 85.5118C39.9332 82.8228 43.1453 81.6988 45.3047 83.4162L46.9443 84.7201C48.5621 86.0068 50.9162 85.7415 52.2072 84.1271L53.5154 82.4911C55.2385 80.3362 58.6202 80.7173 59.8206 83.2015L60.732 85.0876C61.6314 86.9489 63.8674 87.7313 65.7311 86.8368L67.6196 85.9305C70.107 84.7367 72.9885 86.5472 72.9922 89.3063L72.9949 91.401C72.9977 93.4682 74.6728 95.1433 76.7399 95.146L78.8347 95.1488C81.5938 95.1525 83.4043 98.034 82.2105 100.521L81.3042 102.41C80.4097 104.274 81.1921 106.51 83.0534 107.409L84.9395 108.32C87.4237 109.521 87.8047 112.902 85.6499 114.626L84.0139 115.934C82.3995 117.225 82.1342 119.579 83.4209 121.197L84.7248 122.836C86.4422 124.996 85.3182 128.208 82.6292 128.825L80.5875 129.294C78.5728 129.757 77.3125 131.763 77.7698 133.779L78.2332 135.821C78.8435 138.512 76.4372 140.918 73.7465 140.308L71.7036 139.845C69.6877 139.387 67.6818 140.648 67.2192 142.662L66.7503 144.704C66.1328 147.393 62.9207 148.517 60.7613 146.8L59.1218 145.496C57.5039 144.209 55.1499 144.474 53.8589 146.089L52.5506 147.725C50.8275 149.88 47.4458 149.499 46.2454 147.014L45.334 145.128C44.4346 143.267 42.1986 142.485 40.335 143.379L38.4464 144.285C35.959 145.479 33.0776 143.669 33.0739 140.91L33.0711 138.815C33.0683 136.748 31.3932 135.073 29.3261 135.07L27.2313 135.067C24.4722 135.063 22.6617 132.182 23.8555 129.695L24.7619 127.806C25.6563 125.942 24.8739 123.706 23.0126 122.807L21.1265 121.896C18.6423 120.695 18.2613 117.314 20.4161 115.59L22.0521 114.282C23.6666 112.991 23.9318 110.637 22.6451 109.019L21.3412 107.38C19.6239 105.22 20.7478 102.008 23.4369 101.391L25.4785 100.922C27.4932 100.459 28.7536 98.4533 28.2963 96.4374L27.8329 94.3945Z",
    fill: "#00A3A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27259_7329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 12.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelsIconLight);
export default __webpack_public_path__ + "static/media/wheelsIconLight.e7b0321ecc1144451a74922d0658e999.svg";
export { ForwardRef as ReactComponent };